<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Boards|Boards') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'Boards|Boards allow you to visualize and organize tasks using a Kanban-style interface. You can create multiple boards, each with custom columns, filters, and sorting options.'
                )
              }}
            </p>

            <h4>{{ s__('Boards|Creating Boards') }}</h4>
            <p>
              {{
                s__(
                  'Boards|Click "New Board" to create a board. You can set a title, description, and default sorting options. Each board can be customized independently.'
                )
              }}
            </p>

            <h4>{{ s__('Boards|Personal vs Project Boards') }}</h4>
            <p>
              {{
                s__(
                  'Boards|Personal boards are visible only to you and can show tasks from any project. Project boards are shared with all project members and show only tasks from that specific project.'
                )
              }}
            </p>

            <h4>{{ s__('Boards|Managing Boards') }}</h4>
            <p>
              {{
                s__(
                  'Boards|Use the Edit button to modify board settings, or Delete to remove a board. Project owners can manage project boards, while personal boards can be managed by their creators.'
                )
              }}
            </p>

            <h4>{{ s__('Boards|Working with Boards') }}</h4>
            <p>
              {{
                s__(
                  'Boards|To configure columns, filters, ordering, and swimlanes, click on a board to open it. All board customization options are available on the board page itself.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Boards|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
